<template>
   <common-layout :go-back="goBack" :title="$t('Reset Password')">
      <div class="login-ftth-wrapper">
         <div class="login-ftth">
            <div class="login-ftth-form">
               <input
                  type="text"
                  :placeholder="$t('Account FTTH')"
                  v-model="account"
                  :class="['input', errorMessage ? 'input-error' : '']"
                  maxlength="9"
                  @input="handleAccountInput"
               />
               <!-- <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p> -->
               <input
                  type="password"
                  :placeholder="$t('Password')"
                  v-model="password"
                  class="input"
                  :class="['input', errorMessage ? 'input-error' : '']"
               />
               <p v-if="errorMessage" class="error-text">{{ errorMessage }}</p>
               <div class="actions">
                  <a href="#" class="reset-password" @click="resetPassword">{{ $t('Reset password') }}</a>
               </div>
               <button class="login-btn" @click="login" :disabled="!isFormValid">{{ $t('Login') }}</button>
            </div>
         </div>

         <div class="ftth-guide">
            <div class="guide-content">
               <div class="guide-item">
                  <b class="guide-title">1. {{ $t('Trường hợp quên mật khẩu Khách hàng có thể:') }}</b>
                  <ul class="guide-list">
                     <p
                        class="guide-list-item"
                        v-html="$t('Gọi tổng đài 021 999 888 để được nhân viên hỗ trợ trực tiếp.')"
                     ></p>
                     <p class="guide-list-item">
                        - {{ $t('Đến trung tâm Unitel gần nhất để được hỗ trợ trực tiếp.') }}
                     </p>
                  </ul>
               </div>

               <div class="guide-item">
                  <p
                     class="guide-title"
                     v-html="
                        $t(
                           '2. Trường hợp Quý khách chưa có tài khoản: Vui lòng bấm Đặt hàng FTTH đề tiếp tục đăng ký dịch vụ FTTH.'
                        )
                     "
                  ></p>
               </div>

               <div class="order-link">
                  <a href="#" class="order-status" @click="goToOrderStatus">{{ $t('Tiến độ theo dõi Order') }}</a>
               </div>
               <div class="order-btn-wrapper">
                  <button class="order-btn" @click="goToOrder">{{ $t('Đặt hàng FTTH') }}</button>
               </div>
            </div>
         </div>
      </div>
   </common-layout>
</template>

<script>
import BaseComponent from '@/mixins/BaseComponent'
import CommonLayout from '@/components/layout/CommonLayout.vue'
import service from '@/modules/ftth/services/FTTHService'
import { ValidationObserver } from 'vee-validate'
import Input from '@/components/form/Input'
import LocalStorage from '@/ultils/local-storage'
import { callNative } from '@/ultils/call-native'
import $ from 'jquery'
export default {
   data() {
      return {
         account: '',
         password: '',
         errorMessage: '' // thông báo lỗi
      }
   },
   mixins: [BaseComponent],
   methods: {
      goBack() {
         this.$router.push('/')
      },
      handleAccountInput(event) {
         let input = event.target.value

         // Loại bỏ tất cả ký tự không phải số
         input = input.replace(/\D/g, '')

         // Giới hạn độ dài 9 ký tự
         if (input.length > 9) {
            input = input.slice(0, 9)
         }

         this.account = input
      },
      goToOrderStatus() {
         const phoneNumber = this.userInfo?.isdn
         const language = localStorage.getItem('lang') || 'en'
         const url = `https://saleman.unitel.com.la:8680/follow-order-ftth?msisdn=${phoneNumber}&language=${language}`
         window.location.href = url
      },
      goToOrder() {
         const phoneNumber = this.userInfo?.isdn // bạn có thể thay bằng biến nếu cần động
         let language = localStorage.getItem('lang') || 'en'
         if (language === 'cn') {
            language = 'zh'
         }
         const url = `https://telecom.u-money.com.la:8088/#/ftth-sale?phoneNumber=${phoneNumber}&lang=${language}&deepLink=u-money://my_unitel`
         window.location.href = url
      },
      resetPassword() {
         this.$router.push('/ftth/reset-password')
      },
      //check xem dang nhap chua
      checkAccount() {
         this.showLoading()
         service
            .getListFtthAccountInfo()
            .then((response) => {
               let accounts = response.wsResponse ?? []
               if (accounts.length > 0) {
                  this.userInfo.originalUrl = '/ftth/account-list'
                  LocalStorage.setItem('user_info', JSON.stringify(this.userInfo))
                  LocalStorage.setItem('ftth_list_account', JSON.stringify(accounts))
                  let onConfirmLogout = LocalStorage.getItem('onConfirmLogout')
                  if (!onConfirmLogout) {
                     this.$router.push('/ftth/account-list')
                     LocalStorage.removeItem('onConfirmLogout')
                  }
               }
            })
            .finally(() => {
               this.hideLoading()
            })
      },
      //API LOGIN
      async login() {
         this.showLoading()
         service
            .login({ accountType: '1', username: this.account, password: this.password })
            .then((response) => {
               if (!response.errorMessage) {
                  let ftthUserInfo = {
                     token: response.token,
                     isdn: response.username,
                     sessionId: response.sessionId
                  }
                  LocalStorage.setItem('ftth_user_info', JSON.stringify(ftthUserInfo))

                  callNative('ftthAccount', this.account)
                  LocalStorage.setItem('ftth_account', this.account)
                  LocalStorage.setItem('ftth_account_login', this.account)

                  // GOI API SET ftth_account_info
                  this.createMapAccount()

                  // // Emit sự kiện login thành công
                  // this.$emit('login-success')

                  this.hideLoading()
                  //Push ve home tab ftth
               } else {
                  this.errorMessage = this.$t('Tài khoản hoặc mật khẩu không đúng.')
                  this.hideLoading()
               }
            })
            .catch(() => {
               this.errorMessage = this.$t('Tài khoản hoặc mật khẩu không đúng.')
               this.hideLoading()
            })
      },
      async createMapAccount() {
         this.showLoading()

         try {
            const response = await service.wsCreateMapAccount({
               isdn: this.userInfo?.isdn,
               accountFtth: this.account
            })

            if (response.errorCode === '0' || response.errorCode === '200') {
               localStorage.setItem('just_logged_in', true)
               const currentPath = this.$route.path
               const original = response?.wsResponse
               console.log('currentPathcurrentPath', currentPath)

               const account = {
                  ...original,
                  account: original.accountId, // gán accountId sang account
                  prodPackageCode: original.packageName,
                  prodPackagePrice: original.packagePrice
               }

               // Xử lý localStorage key_ftth_data
               const rawData = localStorage.getItem('key_ftth_data')
               let parsedData = []

               if (rawData) {
                  try {
                     parsedData = JSON.parse(rawData)
                  } catch (e) {
                     console.error('Lỗi parse key_ftth_data:', e)
                     parsedData = []
                  }
               }

               // Kiểm tra trùng tài khoản theo field `account`
               const existed = parsedData.some((item) => item.account === account.account)

               console.log(existed, 'existedexisted')

               if (!existed) {
                  parsedData.push(account)
                  localStorage.setItem('key_ftth_data', JSON.stringify(parsedData))
                  //    // Gán lại acc đầu tiền của key_ftth_data
                  console.log('account1', account)
                  if (parsedData.length > 0) {
                     localStorage.setItem('ftth_account_info', JSON.stringify(account[0]))
                  }
                  // else {
                  //    localStorage.removeItem('ftth_account_info')
                  // }
               }
               // else {
               //    console.log('account12',account)
               //    localStorage.setItem('key_ftth_data', JSON.stringify(account))
               //    localStorage.setItem('ftth_account_info', JSON.stringify(account[0]))
               // }

               console.log('currentPath')
               if (currentPath === '/ftth/login') {
                  // Nếu không thì chuyển route như bình thường
                  this.$router.push({ path: '/', query: { tab: 'ftth' } })
               } else {
                  // Nếu đang ở root `/`, thì reload lại trang
                  window.location.replace('#/?tab=ftth')
                  window.location.reload()
               }
            } else {
               this.errorMessage = response.userMsg
            }
         } catch (error) {
            console.error('Lỗi khi gọi getFtthAccountSameCust:', error)
         } finally {
            setTimeout(() => {
               this.hideLoading()
            }, 1400)
         }
      }
   },

   created() {
      this.userInfo = JSON.parse(LocalStorage.getItem('user_info'))
      if (this.userInfo && this.userInfo.originalUrl) {
         this.checkAccount()
      } else {
         this.setTitle(this.$i18n.t('ftth.ftth_service'))
      }
   },
   computed: {
      isFormValid() {
         return this.account.trim() !== '' && this.password.trim() !== ''
      }
   }
}
</script>

<style scoped>
.login-ftth {
   background-color: white;
   padding: 20px;
   margin: 0px 20px 0px 20px;
   border-radius: 20px;
}
.login-ftth-form {
   margin: 0 auto;
   display: flex;
   flex-direction: column;
}
.input {
   background: #f5f5f5;
   border: none;
   border-radius: 10px;
   padding: 9px 16px;
   font-size: 15px;
   color: black !important;
   margin-bottom: 10px;
}
.input:focus {
   outline: none;
   background: #eee;
}
.input-error {
   border: 1px solid #c6110c !important;
}

.error-text {
   color: #c6110c;
   font-size: 13px;
   margin-top: 4px;
   margin-bottom: 10px;
}
.actions {
   display: flex;
   justify-content: flex-end;
   margin-bottom: 18px;
}
.reset-password {
   color: #ed5c19;
   font-size: 13px;
   text-decoration: none;
   text-decoration: underline;
}
.login-btn {
   background: #ed5c19;
   color: #fff;
   border: none;
   border-radius: 100px;
   padding: 9px 0;
   font-size: 15px;
   font-weight: bold;
   min-width: 160px;
   margin: 0 auto;
}
.login-btn:disabled {
   background-color: #ccc;
   color: #888;
   cursor: not-allowed;
}
.ftth-guide {
   background: #fff;
   border: 1px solid #ed5c19;
   border-radius: 16px;
   padding: 20px;
   margin: 20px 20px 20px 20px;
   color: #222;
   font-size: 15px;
   margin-bottom: 20px;
}

.high-light-value {
   color: black !important;
}

.guide-content ul {
   margin: 0px 0 10px 0px;
   padding: 0;
}
.guide-content li {
   margin-bottom: 2px;
}
.order-link {
   text-align: right;
   margin: 8px 0 10px 0;
}
.order-status {
   color: #ed5c19;
   font-size: 13px;
   text-decoration: underline;
   cursor: pointer;
}
.order-btn-wrapper {
   display: flex;
   justify-content: center;
}
.order-btn {
   background: #ed5c19;
   color: #fff;
   border: none;
   border-radius: 100px;
   padding: 9px 0;
   font-size: 15px;
   font-weight: bold;
   min-width: 160px;
   margin: 0 auto;
}
.guide-item {
   margin-bottom: 4px;
}

.guide-title {
   display: block;
   /* margin-bottom: 8px; */
   font-size: 14px;
}

.guide-list {
   padding-left: 20px;
   margin: 0;
}

.guide-list-item {
   /* margin-bottom: 6px; */
   font-size: 14px;
   /* color: #5a5a5a; */
}

.guide-description {
   /* padding-left: 12px; */
   font-size: 14px;
   color: #5a5a5a;
}
</style>
